import Transformer from '../../transformer'

export default class subFamilyTransformer extends Transformer {
  static fetch(subFamily) {
    return {
      id: subFamily.id,
      family: subFamily.family,
      name: subFamily.name,
      codename: subFamily.codename,
      isActive: true,
    }
  }
  
  static send(subFamily) {
    return {
      id: subFamily.id,
      family: subFamily.family,
      name: subFamily.name,
      codename: subFamily.codename,
    }
  }
}


// WEBPACK FOOTER //
// ./src/transformers/catalog/supplys/subFamily.js